
import { useSelector } from "react-redux";
import { selectCurrentPage } from "context/pages/pageSlice";

import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';

import { Card } from "@mui/material";
import MDBox from "dashboard/components/MDBox";

// import ProductSideBar from "components/Home/products/sections/ProductSideBar";
// import ProductTopBar from "components/Home/products/sections/ProductTopBar";
import Navigation  from "components/Home/components/navigation";
import LandingFooter from "components/Home/components/landingFooter";
import Product from "components/Home/products/sections/Products";
// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";
/* eslint-disable */


const parseContent = content => parse(DOMPurify?.sanitize(content));

const  limitTextToWords = (text, maxWords = 100)=>{
  if(typeof text !== "string" ) return "...";
  // Split the text into an array of words
  const words = text.split(' ');

  // If the number of words is less than or equal to the limit, return the original text
  if (words.length <= maxWords) {
    return text;
  }

  // Otherwise, slice the array to get the first 'maxWords' words and join them back into a string
  const limitedText = words.slice(0, maxWords).join(' ');

  // Add an ellipsis (...) to indicate that the text has been truncated
  return limitedText + '...';
}



const Products = () => {
  const pageContent = useSelector(selectCurrentPage);

  return (
    <>
    <MDBox
        minHeight={{xs:"20vh" , lg: "55vh"}}
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          marginTop : pageContent.Menu ? "225px" : "150px"
        }}
      />
       {pageContent.Navigation?.navBar && <Navigation parseContent={parseContent} data={{ navBar : pageContent.Navigation?.navBar, logo : pageContent.Navigation.logo?.selectedImage,  menu: pageContent.Menu }}  />}
      <Card
        sx={{
          px: { xs: 1, lg: 2 },
          mx: { xs: .5, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { background }, functions: { rgba } }) => rgba(background.card, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
      <Product parseContent={parseContent} />
    </Card>
    {pageContent.Contact && <LandingFooter data={pageContent.Contact} feed={pageContent.Features} limitTextToWords={limitTextToWords} about={pageContent.About} navBar={pageContent.Navigation?.navBar} logo={pageContent.Navigation.logo?.selectedImage} parseContent={parseContent}/>}
  </>
  )
}

export default Products